import React from 'react'
import Select, { SelectProps } from './Select'
import { Control, Controller, RegisterOptions } from 'react-hook-form'
import Field from './Field'

interface IProps extends SelectProps {
  control: Control<any>
  rules?: RegisterOptions
}

const SelectForForm: React.FC<IProps> = (props) => {
  return (
    <Controller
      control={props.control}
      rules={props.rules}
      render={({ field }) => {
        return (
          <Field
            className={props.className}
            required={props.required}
            disabled={props.disabled}
            hideDetails={props.hideDetails}
            helpText={props.helpText}
            hasError={props.hasError}
            errorText={props.errorText}
            render={() => {
              return (
                <Select
                  {...{ ...props, control: undefined, rules: undefined }}
                  value={field.value}
                  onChange={field.onChange}
                  onClose={field.onBlur}
                ></Select>
              )
            }}
          ></Field>
        )
      }}
      name={props.name ?? ''}
    ></Controller>
  )
}

export default SelectForForm
